import { makeAutoObservable } from 'mobx';
import * as utils from '@intrasync/utils';

import DataGridStoreNameSpace from './DataGridStoreNamespace';
import RootStore from '../RootStore';

class DataGridStore {
  rootStore;
  namespaces: { [key: string]: DataGridStoreNameSpace } = {};

  constructor(rootStore: RootStore) {
    makeAutoObservable(this, { rootStore: false });
    this.rootStore = rootStore;
  }

  setupNamespace = (namespaceId?: string): string => {
    if (!namespaceId) {
      const randomId: string = utils.uuid();
      this.namespaces[randomId] = new DataGridStoreNameSpace(
        this.rootStore,
        randomId
      );
      return randomId;
    }
    this.namespaces[namespaceId] = new DataGridStoreNameSpace(
      this.rootStore,
      namespaceId
    );
    return namespaceId;
  };

  clearNamespace = (namespaceId: string): void => {
    console.log('clearNamespace namespaceId', namespaceId);
    if (this.namespaces[namespaceId]) {
      delete this.namespaces[namespaceId];
    }
  };

  clearAllNamespaces = () => {
    console.log('clearAllNamespaces');
    this.namespaces = {};
  };

  get availableNameSpaces() {
    return Object.keys(this.namespaces);
  }
}

export default DataGridStore;
